export default __webpack_public_path__ + "media/images/icons/car-side-solid-24b12ab2f4c503f6e8c022e7c9f1c369.svg";